import primaryEnrolmentReport from "./primaryEnrolmentReport.vue";
export default primaryEnrolmentReport;
